import React from "react";
import { fetchUserDetails , fetchVideoList} from "../../api/user"
import $ from "jquery"

class KeysuccessInfoProgress extends React.Component {

    constructor(props) {

        super(props)
        this.state = {
            type : '',
            userName : '',
            videoList : null
        }
    }
    
    componentDidMount() {

        let user_id = sessionStorage.getItem("user_id");
        if(user_id) {
            this.props.changeLoaderStatus(true)
            $(".loading").addClass("active show");
            let user = fetchUserDetails(user_id);
            let that = this
            user.then(function (val)  {


                let username = val.data.user.first_name + " " + val.data.user.last_name 

                let uservideos = fetchVideoList({user_id : user_id});
                uservideos.then(function (val)  {

                    //that.props.changeLoaderStatus(false)
                    $(".loading").removeClass("active show");

        
                    that.setState({
                        videoList : val.data.video_list,
                        userName : username
                    })

                })
        


            })

        }


    }
    updateSelectedCheck = (type) => {

        this.setState({ type : type})
    }

    renderNewProductarea = () => {

        this.props.changeLoaderStatus(true)
        this.props.changeRender360Map("thermatru_new_products")
        $("#myModal").modal("hide")

        setTimeout(() => {

            this.props.changeLoaderStatus(false)

        },10)

    }

    render() {

        return(
            <div className="key_success_imgPopup">
                <img src="images/keys_success_img_latest.png" alt="" className="w-100" />
                <div className="key_success_arrow float-right">
                <a href="#" onClick={() => { this.props.changeModalPopupDisplayData('keysuccess_prize') }}><img src="images/pop_left_arrow.png" alt="" className="mr-3" /></a>
                    <a href="#" onClick={() => { this.props.changeModalPopupDisplayData('keysuccess_rules') }}><img src="images/pop_right_arrow.png" alt="" className="" /></a>
                </div>
                <span className="progress_user_name">{this.state.userName}</span>

                <div className="main_toggle_div">
                    <ul className="key_listing">
                        {
                            this.state.videoList && this.state.videoList.map(val => {
                                if(val.video_status === "No"){
                                    return(
                                        <li>{val.title}</li>
                                    )
                                }else{
                                    return(
                                        <li className="active">{val.title}</li>
                                    )
                                }
                              
                            })
                        }


                    </ul>

                </div>
                <div className="main_toggle_div_under_text">
                    <p>To access videos, please navigate to the <a href="#" onClick={this.renderNewProductarea}>New Products</a> area within the Virtual Experience</p>
                </div>
                <div className="pop_redio_div">
                    <label className="redio_btn_div"
                                     onMouseOver={ () => this.updateSelectedCheck('prize')}
                                     onMouseLeave={ () => this.updateSelectedCheck('')}
                    >See All Prizes
                        <input type="radio"  name="radio" value="prize"   checked={this.state.type === "prize"}
                                        onClick={() => { 
                                            this.setState({ type : 'prize'})
                                        this.props.changeModalPopupDisplayData('keysuccess_prize') 

                                        }}
                                        
                                        />
                        <span className="checkmark"></span>
                    </label>
                    <label className="redio_btn_div"
                    onMouseOver={ () => this.updateSelectedCheck('rules')}
                    onMouseLeave={ () => this.updateSelectedCheck('')}
                    >Rules
                        <input type="radio"  name="radio" value="rules"   checked={this.state.type === "rules"}
                                        onClick={() => { this.setState({ type : 'rules'})
                                        this.props.changeModalPopupDisplayData('keysuccess_rules') 

                                        }}
                                        
                                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>

        )

    }
}

export default KeysuccessInfoProgress;